<template lang="pug">

  section.footer-laboratorio
    a(href="https://www.latercera.com/", title="La Tercera", target="_blank")
      img(:src="`${baseUrl}assets/images/logos-white/latercera.svg`" ).white

    a(href="https://www.laboratoriodecontenidos.cl", title="Icarito", target="_blank")
      img(:src="`${baseUrl}assets/images/logos-white/laboratorio-de-contenidos-de-marca.svg`").white

</template>

<script>
  export default  {
    data () {
      return {
        baseUrl: process.env.BASE_URL
      }
    }
  }
</script>

<style scoped lang="scss">
  .footer-laboratorio {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    align-items: center;
    justify-content: center;
    max-width: 100vw;
    a{
      width: auto;
      display: flex;
      justify-content: center;
    }
    img{
      max-height: 60px;
      max-width: 180px;
      width: 100%;
    }
  }
</style>
